import React from "react";
import { render } from "react-dom";
import { BarChart, CartesianGrid, Cell, YAxis, Bar, ResponsiveContainer } from "recharts";
import { formatPrice } from "../../DocumentSection/utils/helper";

const Label = props => {
  const { x, y, value, color, name } = props;
  return (
    <text
      x={x}
      y={y}
      dx={"-2%"}
      dy={"1%"}
      fontSize="11"
      fontWeight="bold"
      fill={"#181818"}
      textAnchor="left"
    >
      {`${name === "units" ? value : ("$" + (formatPrice({price: value}) || 0))}`}
    </text>
  );
};

export default function BarChartBos({barChartData, label, totalValue}){
    const getYAxisWidth = () => {
        const maxYValue = Math.max(...(barChartData?.map(d => d.y) || []));
        return maxYValue.toString().length * 5 + 13;
    };

    return <div style={{width: "100%", height: "500px"}}>
        <div style={{padding: "5px 10px", fontSize: "16px", color: "#9a9a9a", textAlign: "center", fontWeight: 600}}>{label}: {(label === "Unit") ? totalValue : `$${formatPrice({price: totalValue}) || 0}`}</div>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={barChartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <YAxis tick={{ fontSize: 11 }} width={getYAxisWidth()}/>
              <Bar dataKey="y" label={<Label />}>
                  {barChartData?.map((entry, index) => (
                      <Cell 
                          key={`cell-${index}`} 
                          fill={entry.color} // Use entry.color or fallback color
                      />
                  ))}
              </Bar>
          </BarChart>
        </ResponsiveContainer>
    </div>
};
